module.exports = __webpack_public_path__ + "static/media/romanticos_feminino_sapatos.4195180c.jpg";